"use strict";

exports.__esModule = true;
exports.CreateButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * A create button to distinguish create and other buttons.
 *
 * This is a simple wrapper around [blueprintjs's button](http://blueprintjs.com/docs/v2/#core/components/button), with
 * a couple of additional props.
 *
 * @component
 */
var CreateButton = exports.CreateButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "CreateButton",
  componentId: "sc-1jpegbr-0"
})(["&:hover.", ":not([class*=\"bp6-intent-\"]){background:", ";}&.", ":not([class*=\"bp6-intent-\"]){background:", ";border:1px solid ", ";border-radius:20px;}& svg.", ",span.", "-text{color:", ";}"], _core.Classes.BUTTON, (0, _Theme.val)("CreateButtonHoverBackground"), _core.Classes.BUTTON, (0, _Theme.val)("CreateButtonBackground"), (0, _Theme.val)("CreateButtonBorderColor"), _core.Classes.ICON, _core.Classes.BUTON, (0, _Theme.val)("CreateButtonColor"));